"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M14.116 6.68a.5.5 0 0 1 .704-.064l6 5a.5.5 0 0 1 0 .768l-6 5a.5.5 0 0 1-.64-.768l4.939-4.116H3.5a.5.5 0 1 1 0-1h15.619l-4.94-4.116a.5.5 0 0 1-.063-.704"
}), 'ArrowRightSubmit');
//# sourceMappingURL=index.js.map